import React from 'react';

const PageLoader = () => (
  <div className="slg-l-page-loader">
    <span className="sui-a-loader as--xl as--start" />
  </div>
);

export default PageLoader;
